// Date picker strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.datefield.wd.0': 'Su',
  'ds.datefield.wd.1': 'Mo',
  'ds.datefield.wd.2': 'Tu',
  'ds.datefield.wd.3': 'We',
  'ds.datefield.wd.4': 'Th',
  'ds.datefield.wd.5': 'Fr',
  'ds.datefield.wd.6': 'Sa',
  'ds.datefield.month.0': 'January',
  'ds.datefield.month.1': 'February',
  'ds.datefield.month.2': 'March',
  'ds.datefield.month.3': 'April',
  'ds.datefield.month.4': 'May',
  'ds.datefield.month.5': 'June',
  'ds.datefield.month.6': 'July',
  'ds.datefield.month.7': 'August',
  'ds.datefield.month.8': 'September',
  'ds.datefield.month.9': 'October',
  'ds.datefield.month.10': 'November',
  'ds.datefield.month.11': 'December',
  'ds.datefield.placeholder': 'Select date',
  'ds.datefield.choose': 'Choose date',
  'ds.datefield.prev_month': 'Previous month',
  'ds.datefield.next_month': 'Next month',
  'ds.datefield.today': 'Today',
  'ds.datefield.clear': 'Clear',
}

export const zhTW = {
  'ds.datefield.wd.0': '日',
  'ds.datefield.wd.1': '一',
  'ds.datefield.wd.2': '二',
  'ds.datefield.wd.3': '三',
  'ds.datefield.wd.4': '四',
  'ds.datefield.wd.5': '五',
  'ds.datefield.wd.6': '六',
  'ds.datefield.month.0': '一月',
  'ds.datefield.month.1': '二月',
  'ds.datefield.month.2': '三月',
  'ds.datefield.month.3': '四月',
  'ds.datefield.month.4': '五月',
  'ds.datefield.month.5': '六月',
  'ds.datefield.month.6': '七月',
  'ds.datefield.month.7': '八月',
  'ds.datefield.month.8': '九月',
  'ds.datefield.month.9': '十月',
  'ds.datefield.month.10': '十一月',
  'ds.datefield.month.11': '十二月',
  'ds.datefield.placeholder': '選擇日期',
  'ds.datefield.choose': '選擇日期',
  'ds.datefield.prev_month': '上一個月',
  'ds.datefield.next_month': '下一個月',
  'ds.datefield.today': '今天',
  'ds.datefield.clear': '清除',
}
